app.controller('AccountAddressEditController', ['$rootScope', '$scope', '$stateParams', function ($rootScope, $scope, $stateParams) {

    const addressID = $stateParams.address_id;

    $scope.had_valid_address = false;

    $scope.view_model = {
        show_confirm_delete: false,
    }

    $scope.getEditAddress = function () {
        return addressID ? $rootScope.model.account.user_data.addresses[addressID] : null;
    }

    $rootScope.service.account.requireMinimumData(function () {
        $scope.had_valid_address = !!$scope.getEditAddress();
    });

    $scope.editAddress = function (validateFormCallback) {
        $scope.view_model.show_confirm_delete = false;

        const address = $scope.getEditAddress();
        $scope.form_disabled = true;
        $rootScope.service.account.editAddress(address, function (success, address, messages) {
            $scope.form_disabled = false;
            if (success) {
                $rootScope.site_helper.addSuccessMessage('Address successfully updated!', messages);
            }
            validateFormCallback(success, messages);
        });

    };

    $scope.deleteAddress = function (setAlerts) {

        const address = $scope.getEditAddress();
        setAlerts([]);
        $scope.form_disabled = true;
        $rootScope.service.account.deleteAddress(address._id, function (success, data, messages) {
            $scope.form_disabled = false;
            $scope.view_model.show_confirm_delete = false;
            setAlerts(messages);
        });
    };

}]);
